module.exports = __webpack_public_path__ + "static/media/facebookIcon.91d35980.svg";